/**
 * @generated SignedSource<<e9a9af4e511af82de784f95be1d07c60>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type CreditLimitRevealPageQuery$variables = Record<PropertyKey, never>;
export type CreditLimitRevealPageQuery$data = {
  readonly authIdentity: {
    readonly creditApplications: ReadonlyArray<{
      readonly id: string;
      readonly selectedTerms: {
        readonly limitMaxMicro: number;
      } | null;
    }>;
    readonly id: string;
  };
};
export type CreditLimitRevealPageQuery = {
  response: CreditLimitRevealPageQuery$data;
  variables: CreditLimitRevealPageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v1 = [
      {
        alias: null,
        args: null,
        concreteType: 'Identity',
        kind: 'LinkedField',
        name: 'authIdentity',
        plural: false,
        selections: [
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'CreditApplication',
            kind: 'LinkedField',
            name: 'creditApplications',
            plural: true,
            selections: [
              v0 /*: any*/,
              {
                alias: null,
                args: null,
                concreteType: 'CreditTerms',
                kind: 'LinkedField',
                name: 'selectedTerms',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'limitMaxMicro',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'CreditLimitRevealPageQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'CreditLimitRevealPageQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'dc5ac760a3ec2002574069590f9276ae',
      id: null,
      metadata: {},
      name: 'CreditLimitRevealPageQuery',
      operationKind: 'query',
      text: 'query CreditLimitRevealPageQuery {\n  authIdentity {\n    id\n    creditApplications {\n      id\n      selectedTerms {\n        limitMaxMicro\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'cb64809c21708e74c9b9d0af23c3f88e';

export default node;
